import classnames from 'classnames/bind'
import React from 'react'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface SliderBulletsProps {
  className?: string
  currentSlideIndex?: number
  indexes?: number
}

function SliderBullets({
  className,
  currentSlideIndex,
  indexes,
}: SliderBulletsProps) {
  let bulletsArray = new Array(indexes).fill(null)

  return (
    <div className={cx(css.SliderBullets, className)}>
      {bulletsArray.map((item, index) => {
        const isActive = index === currentSlideIndex

        return (
          <span
            className={cx(css.bullet, { isActive })}
            key={`bullet_${index}`}></span>
        )
      })}
    </div>
  )
}

SliderBullets.defaultProps = {}

export default SliderBullets
